import clsx from "clsx";
import { NavLink } from "react-router-dom";

import Barney from "../../../assets/barney.png";
import { INavigationItem } from "../../../types/Navigation";

export interface DesktopSidebarProps {
  navigation: INavigationItem[];
}

export default function DesktopSidebar({ navigation }: DesktopSidebarProps) {
  return (
    <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
      {/* Sidebar component, swap this element with another sidebar if you like */}
      <div className="flex flex-grow flex-col overflow-y-auto bg-slate-800 pt-5">
        <div className="flex flex-shrink-0 justify-center items-center px-4 text-slate-100">
          <img className="h-20 w-auto" src={Barney} alt="Barney Logo" />
          <div className="flex flex-col items-center font-stick text-2xl">
            <p>Barney</p>
          </div>
        </div>
        <div className="mt-5 flex flex-1 flex-col">
          <nav className="flex-1 space-y-1 px-2 pb-4 text-white">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.to}
                className={({ isActive }) =>
                  clsx(
                    "group flex items-center px-2 py-2 text-sm font-medium rounded-md",
                    isActive && "bg-orange-600",
                  )
                }
              >
                <item.icon
                  className="mr-3 h-6 w-6 flex-shrink-0 text-currentColor"
                  aria-hidden="true"
                />
                {item.name}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
